import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  forwardEvaluationFailed,
  forwardEvaluationSuccess,
  forwardEvaluationStart,
} from "../redux/forwardEvaluation";

import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  getListCandidateCampaignStart,
  resetListCandidateCampaign,
} from "../redux/getList";
import { toast } from "react-toastify";
import { forwardEvaluationApi } from "core/http/service/evaluation";

function* forwardEvaluationWork(
  action: ReturnType<typeof forwardEvaluationStart>
) {
  try {
    const { callback, ...rest } = action.payload;

    const res = yield call(forwardEvaluationApi, rest);
    yield put({
      type: forwardEvaluationSuccess.type,
      payload: {
        data: res.data,
      },
    });

    yield put({
      type: resetControlPage.type,
      payload: "candidateCampaign",
    });

    yield put({
      type: resetListCandidateCampaign.type,
    });

    yield put({
      type: getListCandidateCampaignStart.type,
      payload: {
        screenCode: rest.screenCode,
      },
    });
    toast.success("Ủy quyền đánh giá thành công!");

    if (callback) {
      callback();
    }
  } catch (error: any) {
    yield put({
      type: forwardEvaluationFailed.type,
    });
  }
}

function* watchForwardEvaluation() {
  yield takeLatest(forwardEvaluationStart.type, forwardEvaluationWork);
}

export default function* forwardEvaluationSaga() {
  yield all([watchForwardEvaluation()]);
}
